import React, { useState } from 'react'
import SearchInput from '../../../components/GroupsTable/SearchInput'
import MUINotificationTable from './MUINotificationTable'

interface GroupTablePops {
  setSnackBarInfo?: any
}

const NotificationTable = ({ setSnackBarInfo }: GroupTablePops) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [open, setOpen] = useState(false)

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event?.target?.value)
  }

  const handleClickSearch = (term?: string) => {
    const newQuery = term?.trim()?.replace(/\s+/g, ' ') ?? searchTerm?.trim()?.replace(/\s+/g, ' ')
    setSearchQuery(newQuery || '')
    setSearchTerm(newQuery || '')
  }

  return (
    <>
      <div className='p-6 border-2 rounded-xl bg-white shadow w-full'>
        <div className='flex justify-end sm:items-center  gap-2 p-4 sm:flex-row flex-col'>
          <SearchInput
            placeholder='Search by Gateway UID'
            value={searchTerm}
            onChange={handleSearch}
            setSearchTerm={(val: string) => {
              setSearchTerm(val?.trim()?.replace(/\s+/g, ' '))
              if (val?.trim()?.replace(/\s+/g, ' ') === '') handleSearch('' as any)
            }}
            onSearch={handleClickSearch}
            isSelectSearch={true}
          />
        </div>
        <div className='bg-white rounded-lg overflow-hidden'>
          <MUINotificationTable
            searchTerm={searchQuery?.trim()?.replace(/\s+/g, ' ')}
            setModalOpen={setOpen}
            modalOpen={open}
            setSnackBarInfo={setSnackBarInfo}
          />
        </div>
      </div>
    </>
  )
}

export default NotificationTable
